/**
 * Ukrainian translations (default)
 */

export const uk = {
  // Common
  common: {
    save: 'Зберегти',
    cancel: 'Скасувати',
    close: 'Закрити',
    back: 'Назад',
    next: 'Далі',
    loading: 'Завантаження...',
    saving: 'Збереження...',
    error: 'Помилка',
    success: 'Успіх',
    recommended: 'Рекомендовано',
    minutes: 'хвилин',
  },

  // Greetings (Header)
  greetings: {
    goodMorning: 'Доброго ранку',
    goodAfternoon: 'Добрий день',
    goodEvening: 'Добрий вечір',
    goodNight: 'Доброї ночі',
  },

  // Profile page
  profile: {
    title: 'Профіль',
    uploading: 'Завантаження...',
    edit: 'Редагувати',
    starsEarned: 'Зірок зібрано',
    badges: 'Досягнення',
    badgesEarned: 'Досягнень отримано',
    longestStreak: 'Найдовша серія',
    days: 'днів',
    accountSecurity: 'Безпека акаунту',
    helpAndSupport: 'Допомога та підтримка',
    signOut: 'Вийти',
    signingOut: 'Виходимо...',
    memberSince: 'Учасник з',
    lessonsCompleted: 'уроків завершено',
    levelProgress: 'Прогрес рівня',
    level: 'Рівень',
    levelLabels: {
      A1: 'Початківець',
      A2: 'Елементарний',
      B1: 'Середній',
      B2: 'Вище середнього',
      C1: 'Просунутий',
      C2: 'Вільне володіння',
    },
    levelDescriptions: {
      A1: 'Початок подорожі',
      A2: 'Будуємо основи',
      B1: 'Зростаюча впевненість',
      B2: 'Розширюємо горизонти',
      C1: 'Майже як рідна мова',
      C2: 'Експерт мови',
    },
  },

  // Learning Settings
  settings: {
    learningSettings: 'Налаштування навчання',
    displayLanguage: 'Мова інтерфейсу',
    targetLanguage: 'Мова вивчення',
    dailyPracticeGoal: 'Щоденна мета практики',
    tutorVoice: 'Голос репетитора',
    chooseVoice: 'Оберіть голос',
  },

  // Create Own Modal
  createOwn: {
    title: 'Створити свій урок',
    editLesson: 'Редагувати урок',
    lessonTitle: 'Назва уроку',
    lessonTitlePlaceholder: 'напр., У лікаря',
    whatToPractice: 'Що ви хочете практикувати?',
    describePlaceholder: 'Опишіть сценарій або ситуацію, яку хочете відпрацювати...',
    durationInfo: 'Усі власні уроки тривають',
    fiveMinutes: '5 хвилин',
    createLesson: 'Створити урок',
    saveChanges: 'Зберегти зміни',
    failedToSave: 'Не вдалося зберегти урок. Спробуйте ще раз.',
  },

  // Pronunciation Modal
  pronunciation: {
    title: 'Тренер вимови',
    whatWords: 'Які слова або фрази ви хочете практикувати?',
    placeholder: 'напр., comfortable, I\'d like to order, pronunciation',
    hint: 'Введіть слова або фрази через кому',
    quickPractice: 'швидка практика',
    twoMinutes: '2 хвилини',
    startLesson: 'Почати урок',
  },

  // Chat Controls
  chat: {
    offline: 'ОФЛАЙН',
    connecting: "З'ЄДНАННЯ",
    live: 'НАЖИВО',
    speaking: 'ГОВОРИТЬ',
    muted: 'ВИМКНЕНО',
    paused: 'ПАУЗА',
    connectingToAi: "З'єднання з AI...",
    establishingConnection: "Встановлення з'єднання...",
    speakNaturally: 'Говоріть природно — натисніть, щоб завершити',
    aiResponding: 'AI відповідає — натисніть, щоб завершити',
    microphoneMuted: 'Мікрофон вимкнено',
    sessionPaused: 'Сеанс на паузі — натисніть, щоб продовжити',
    endSession: 'Завершити цей сеанс? Ваш час практики буде збережено.',
  },

  // Homepage
  home: {
    upNext: 'Далі',
    allLessons: 'Усі уроки',
    myPractice: 'Мої практики',
    tools: 'Інструменти',
    noLessons: 'Ще немає призначених уроків',
    yourLessons: 'Ваші уроки',
    seeAll: 'Дивитись все',
  },

  // Navigation
  nav: {
    home: 'Головна',
    rolePlay: 'Рольова гра',
    progress: 'Прогрес',
    profile: 'Профіль',
  },

  // Lessons
  lessons: {
    noLessonsYet: 'Уроки ще не доступні.',
    askTeacher: 'Попросіть вчителя призначити!',
    continueLearning: 'Продовжити навчання',
    reviewReady: 'Повторення готове',
    upNext: 'Наступний',
    continueLesson: 'Продовжити урок',
    startLesson: 'Почати урок',
    continueWhereLeft: 'Продовжити з місця зупинки',
    fromTeacher: 'Від',
    done: 'Виконано',
    weeklyReview: 'Тижневе повторення',
    ready: 'Готово',
    wordsToReview: 'слів для практики',
    continue: 'Продовжити',
  },

  // Practice
  practice: {
    createMyOwn: 'Створити свій',
    customPractice: 'Власна практика',
    quickPractice: 'Швидка практика',
    anytime: 'Будь-коли',
    myPractice: 'Мої практики',
    lesson: 'урок',
    lessons: 'уроків',
    editLesson: 'Редагувати урок',
    delete: 'Видалити',
    today: 'Сьогодні',
    yesterday: 'Вчора',
    daysAgo: 'д. тому',
  },

  // Persona
  persona: {
    aiPersona: 'Персона AI',
    actor: 'Актор',
    tutor: 'Репетитор',
    actorDesc: 'Відтворюйте реальні сценарії',
    tutorDesc: 'Навчайтесь з підтримкою',
    actorDetails: 'AI буде грати роль персонажа в реалістичному сценарії. Чудово підходить для практики реальних розмов, як-от замовлення їжі, реєстрація в готелі чи покупки.',
    tutorDetails: 'AI буде діяти як вчитель, виправляючи помилки та пояснюючи граматику. Ідеально для цілеспрямованого навчання та покращення конкретних навичок.',
    active: 'Активний',
    mode: 'Режим',
  },

  // Chat extras
  chatExtras: {
    askedIn: 'Запитано мовою',
    tutorMode: 'Режим репетитора',
    replay: 'Повторити',
    translate: 'Перекласти',
    targetVocab: 'Цільова лексика:',
  },

  // Usage & Subscription
  usage: {
    remainingThisWeek: 'залишилось на цьому тижні',
    planResetsMonday: 'Оновлюється в понеділок',
    dismissWarning: 'Закрити',
    weeklyLimitReached: 'Тижневий ліміт вичерпано',
    goBack: 'Назад',
    contactTeacher: 'Зверніться до вчителя для оновлення плану',
    subscription: 'Підписка',
    thisWeek: 'Цього тижня',
    remaining: 'залишилось',
    unlimitedPractice: 'Безлімітна практика',
    noWeeklyLimits: 'Без тижневих обмежень',
    practicedThisWeek: 'практики цього тижня',
    // Plan names
    planStarter: 'Стартовий',
    planPlus: 'Плюс',
    planUnlimited: 'Безлімітний',
  },

  // Session Lifecycle
  lifecycle: {
    resumeTitle: 'Продовжити сесію?',
    resumeMessage: 'Ви були відсутні {duration}. Продовжити з того місця?',
    resume: 'Продовжити',
    startFresh: 'Почати заново',
    sessionExpired: 'Сесія закінчилась',
    sessionExpiredMessage: 'Ваша сесія була призупинена занадто довго. Будь ласка, почніть нову сесію.',
    startNewSession: 'Почати нову сесію',
    youreOffline: 'Ви офлайн - перевірте з\'єднання',
    fewSeconds: 'кілька секунд',
    oneMinute: '1 хвилину',
    minutes: '{count} хвилин',
  },

  // Role Play
  roleplay: {
    seeAll: 'Дивитись все',
    createYourOwn: 'Створіть власний сценарій!',
    random: 'Випадковий',
    allLessons: 'Усі уроки',
    collections: 'Колекції',
    noLessonsFound: 'Уроки не знайдено',
    tryDifferentLevel: 'Спробуйте вибрати інший рівень.',
    noLessonsForLevel: 'Для цього рівня ще немає уроків.',
    showAll: 'Показати всі',
    showAllLevels: 'Показати всі рівні',
    noCollections: 'Немає доступних колекцій',
    notConnectedToTeacher: 'Не підключено до вчителя',
    joinClassMessage: 'Приєднайтесь до класу за кодом вчителя, щоб отримати доступ до колекцій.',
    practiceLesson: 'Практикуйте цей урок.',
    minuteLesson: '-хвилинний урок',
    description: 'ОПИС',
    tasks: 'ЗАВДАННЯ',
    languageLevel: 'Рівень мови',
    scenes: 'сценаріїв',
  },

  // Levels
  levels: {
    all: 'Усі',
    beginner: 'Початківець',
    preIntermediate: 'Нижче середнього',
    intermediate: 'Середній',
    upperIntermediate: 'Вище середнього',
    advanced: 'Просунутий',
  },

  // Progress Page
  progress: {
    yourProgress: 'Ваш прогрес',
    dayStreak: 'днів поспіль',
    bestStreak: 'Найкраще:',
    days: 'днів',
    achievements: 'Досягнення',
    moreToUnlock: 'ще для відкриття',
    completeToEarn: 'Завершуйте уроки, щоб отримати перше досягнення!',
    item: 'елемент',
    items: 'елементів',
    newThisWeek: 'нових',
    areasToImprove: 'Області для покращення',
    total: 'всього',
    allCaughtUp: 'Все опрацьовано!',
    noMistakesToReview: 'Немає помилок для повторення. Продовжуйте практику!',
    // Motivational messages
    startStreak: 'Почніть свою серію сьогодні!',
    greatStart: 'Чудовий старт! Продовжуйте!',
    buildingMomentum: 'Набираєте обертів!',
    onFire: 'Ви у вогні!',
    incredibleDedication: 'Неймовірна відданість!',
    unstoppable: 'Невпинний учень!',
  },

  // Mistake Types
  mistakes: {
    pronunciation: 'Вимова',
    grammar: 'Граматика',
    vocabulary: 'Словниковий запас',
    cultural: 'Культурні',
  },

  // Review Pages
  review: {
    reviewAndMaster: 'Переглядайте та опановуйте свої помилки',
    toReview: 'До перегляду',
    mastered: 'Опановано',
    all: 'Усі',
    item: 'елемент',
    items: 'елементів',
    somethingWrong: 'Щось пішло не так',
    noMasteredYet: 'Ще немає опанованих елементів',
    markAsMastered: 'Позначайте елементи як опановані, коли вивчите їх.',
    // Empty states
    perfectPronunciation: 'Ідеальна вимова!',
    speechSoundsGreat: 'Ваша мова звучить чудово.',
    grammarOnPoint: 'Граматика на висоті!',
    excellentStructure: 'Ваша структура речень відмінна.',
    wordWizard: 'Майстер слів!',
    impressiveVocabulary: 'Ваш словниковий запас вражає.',
    culturalExpert: 'Культурний експерт!',
    understandNuances: 'Ви добре розумієте нюанси.',
  },

  // Badges
  badges: {
    collection: 'Колекція досягнень',
    complete: 'Виконано',
    all: 'Усі',
    earnedOn: 'Отримано',
    moreToUnlock: 'ще для відкриття!',
    awesome: 'Чудово!',
    keepGoing: 'Продовжуйте!',
  },

  // All Lessons Modal
  allLessonsModal: {
    yourLessons: 'Ваші уроки',
    fromTeacher: 'Від',
    done: 'зроблено',
  },

  // PWA Install
  pwa: {
    installApp: 'Встановити додаток',
    installNotAvailable: 'Встановлення недоступне',
    installNotAvailableDesc: 'Встановлення додатку недоступне в цьому браузері.',
    tryChrome: 'Спробуйте Chrome або Edge для найкращого досвіду.',
    bookmarkTip: 'Ви також можете додати цю сторінку в закладки.',
    gotIt: 'Зрозуміло',
    installTitle: 'Встановити AI English Tutor',
    addToHomeScreen: 'Додайте на головний екран для швидкого доступу',
    tapShare: 'Натисніть кнопку "Поділитися"',
    findInSafari: 'Знайдіть її внизу Safari',
    addToHome: 'На головний екран',
    scrollShareMenu: 'Прокрутіть меню вниз',
    tapAdd: 'Натисніть "Додати"',
    appWillAppear: 'Додаток з\'явиться на головному екрані',
    fasterAccess: 'Швидкий доступ та офлайн режим',
    how: 'Як?',
    install: 'Встановити',
  },

  // Alerts and Messages
  alerts: {
    microphoneRequired: 'Для голосової взаємодії потрібен доступ до мікрофона. Увімкніть мікрофон у налаштуваннях браузера та оновіть сторінку.',
    sessionComplete: 'Сеанс завершено - Чудова практика!',
    failedToStart: 'Не вдалося почати сеанс. Спробуйте ще раз.',
    accountPaused: 'Акаунт призупинено',
    accessPaused: 'Ваш доступ тимчасово призупинено. Зверніться до вчителя для відновлення доступу.',
    viewProfile: 'Переглянути профіль',
  },
} as const;

export type TranslationKeys = typeof uk;
